const healthCheck = [
  {
    path: '/health-check',
    name: 'FulfillmentSettings.HealthCheck',
    meta: {
      requiresAuth: false,
    },
    component: () => import('@/components/HealthCheck.vue'),
  },
];

export {
  healthCheck,
};
